import { ReactElement, ReactNode } from "react";
import { IconProps } from "@phosphor-icons/react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { Drawer } from "./Drawer";
import { Popover } from "./Popover";

interface DrawerAndPopoverProps {
  children?: ReactNode;
  icon?: ReactElement<IconProps>;
  id: string;
  isDismissable?: boolean;
  popoverProps?: { style?: React.CSSProperties };
  triggerProps?: { isDisabled?: boolean };
  externalState?: {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
  };
}

export function DrawerAndPopover({
  id,
  icon,
  isDismissable,
  children,
  popoverProps,
  triggerProps,
  externalState,
}: DrawerAndPopoverProps) {
  const { deviceType } = useBoundStore(useShallow((state) => ({ deviceType: state.device.type })));

  return deviceType === "mobile" ? (
    <Drawer
      isDismissable={isDismissable}
      icon={icon}
      id={id}
      children={children}
      triggerProps={triggerProps}
      externalState={externalState}
    />
  ) : (
    <Popover
      isDismissable={isDismissable}
      icon={icon}
      id={id}
      children={children}
      externalState={externalState}
      style={popoverProps?.style}
      triggerProps={triggerProps}
    />
  );
}
